import Notification from './container/index';

export default Notification;



// WEBPACK FOOTER //
// ./src/components/page/Notification/index.js